import { apiV1 } from "../lib/axios";
import { toast } from "react-toastify";

export function isPasswordStrong(password) {
  if (password.length < 8) {
    return false;
  }

  if (!/[A-Z]/.test(password)) {
    return false;
  }

  if (!/[a-z]/.test(password)) {
    return false;
  }

  if (!/[0-9]/.test(password)) {
    return false;
  }

  if (!/[!@#$%^&*()\-_=+{};:,<.>/?]/.test(password)) {
    return false;
  }

  return true;
}

export async function login(cpf, password, fingerprint) {
  try {
    const loginResponse = await api.post("/login/auth", {
      username: cpf,
      password: password,
      mac: fingerprint,
    });

    if (loginResponse.data.ok) {
      const data = loginResponse.data.data;
      localStorage.setItem("name", data.name);
      localStorage.setItem("taxNumber", data.taxNumber);
      localStorage.setItem("deviceId", fingerprint);
      localStorage.setItem("personId", data.account[0].personId);
      localStorage.setItem("accountId", data.account[0].id);
      localStorage.setItem("bank", data.account[0].bank);
      localStorage.setItem("bankAccount", data.account[0].bankAccount);
      localStorage.setItem("bankAccountDigit", data.account[0].bankAccountDigit);
      localStorage.setItem("bankBranch", data.account[0].bankBranch);
      localStorage.setItem("login", loginResponse.data.login);
      sessionStorage.setItem('access_token', loginResponse.data.accessToken);
      sessionStorage.setItem('refresh_token', loginResponse.data.refreshToken);

      return { ok: true, data: data };
    } else if (
      loginResponse.data.message == "Primeiro login, Altere sua senha"
    ) {
      return { ok: false, loginResponse };
    } else {
      toast.error("Ocorreu um erro! Tente novamente");
      return { ok: false, loginResponse };
    }
  } catch (err) {
    
    return { ok: false, erro: "Usuário ou Senha incorretos!"};
  }
}

export async function forgotPassword(taxNumber, email) {
  try {
    await apiV1.post("/account/forgotpassword", {taxNumber, email});

    return {ok: true}
  } catch (err) {
    return {ok: true, erro: err} // retornando true mesmo com erro, para não dar certeza se CPF e emails estão relacionados, e dar brecha para invasores
  }
}

export async function verifyHash(hash) {
  try {
    await apiV1.post("/account/verifyhash", {temporaryHash : hash});

    return {ok: true}
  } catch (err) {
    return {ok: false, erro: err}
  }
}

export async function changePassword(hash, password, confirmPassword, code) {
    await apiV1.post("/account/changepassword", {temporaryHash : hash, newPassword: password, newConfirmPassword : confirmPassword, code });

    return {ok: true}
}
